import { ark as m } from "@ark-ui/react/factory";
import o, { forwardRef as a } from "react";
import { styled as r } from "@huspy/styled-system/jsx";
import { skeleton as d } from "@huspy/styled-system/recipes";
const l = r(m.div, d), s = a((n, e) => {
  const { isLoaded: i, ...t } = n;
  return i ? /* @__PURE__ */ o.createElement(r.div, { animation: "fade-in", ref: e, ...t }) : /* @__PURE__ */ o.createElement(l, { ref: e, ...t });
});
s.displayName = "Skeleton";
export {
  s as Skeleton
};
